module.exports = require('./dist/index');


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-paypal-express-checkout/index.js
 ** module id = 1042
 ** module chunks = 0
 **/